var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"col",staticClass:"ivu-grid-item",style:(_vm.styles)},[_c('div',{staticClass:"ivu-grid-item-main",style:(_vm.mainStyles)},[_vm._t("default")],2)])}
var staticRenderFns = []
export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/grid/grid-item.vue